import { deburr } from 'lodash'
import React, { ReactNode } from 'react'

const regularGlyphBySubGlyph: { [subglyph: string]: string } = {
  ᵢ: 'i',
  ᵣ: 'r',
  ᵤ: 'u',
  ᵥ: 'v',
  ᵦ: 'β',
  ᵧ: 'γ',
  ᵨ: 'ρ',
  ᵩ: 'φ',
  ᵪ: 'χ',
  '₀': '0',
  '₁': '1',
  '₂': '2',
  '₃': '3',
  '₄': '4',
  '₅': '5',
  '₆': '6',
  '₇': '7',
  '₈': '8',
  '₉': '9',
  '₊': '+',
  '₋': '−',
  '₌': '=',
  '₍': '(',
  '₎': ')',
  ₐ: 'a',
  ₑ: 'e',
  ₒ: 'o',
  ₓ: 'x',
  ₔ: 'ə',
  ₕ: 'h',
  ₖ: 'k',
  ₗ: 'l',
  ₘ: 'm',
  ₙ: 'n',
  ₚ: 'p',
  ₛ: 's',
  ₜ: 't',
}

const regularGlyphBySuperGlyph: { [superglyph: string]: string } = {
  '²': '2',
  '³': '3',
  '¹': '1',
  ʰ: 'h',
  ʱ: 'ɦ',
  ʲ: 'j',
  ʳ: 'r',
  ʴ: 'ɹ',
  ʵ: 'ɻ',
  ʶ: 'ʁ',
  ʷ: 'w',
  ʸ: 'y',
  ˠ: 'ɣ',
  ˡ: 'l',
  ˢ: 's',
  ˣ: 'x',
  ˤ: 'ʕ',
  ᴬ: 'A',
  ᴭ: 'Æ',
  ᴮ: 'B',
  ᴰ: 'D',
  ᴱ: 'E',
  ᴲ: 'Ǝ',
  ᴳ: 'G',
  ᴴ: 'H',
  ᴵ: 'I',
  ᴶ: 'J',
  ᴷ: 'K',
  ᴸ: 'L',
  ᴹ: 'M',
  ᴺ: 'N',
  ᴼ: 'O',
  ᴽ: 'Ȣ',
  ᴾ: 'P',
  ᴿ: 'R',
  ᵀ: 'T',
  ᵁ: 'U',
  ᵂ: 'W',
  ᵃ: 'a',
  ᵄ: 'ɐ',
  ᵅ: 'ɑ',
  ᵆ: 'ᴂ',
  ᵇ: 'b',
  ᵈ: 'd',
  ᵉ: 'e',
  ᵊ: 'ə',
  ᵋ: 'ɛ',
  ᵌ: 'ᴈ',
  ᵍ: 'g',
  ᵏ: 'k',
  ᵐ: 'm',
  ᵑ: 'ŋ',
  ᵒ: 'o',
  ᵓ: 'ɔ',
  ᵔ: 'ᴖ',
  ᵕ: 'ᴗ',
  ᵖ: 'p',
  ᵗ: 't',
  ᵘ: 'u',
  ᵙ: 'ᴝ',
  ᵚ: 'ɯ',
  ᵛ: 'v',
  ᵜ: 'ᴥ',
  ᵝ: 'β',
  ᵞ: 'γ',
  ᵟ: 'δ',
  ᵠ: 'φ',
  ᵡ: 'χ',
  ᵸ: 'н',
  ᶛ: 'ɒ',
  ᶜ: 'c',
  ᶝ: 'ɕ',
  ᶞ: 'ð',
  ᶟ: 'ɜ',
  ᶠ: 'f',
  ᶡ: 'ɟ',
  ᶢ: 'ɡ',
  ᶣ: 'ɥ',
  ᶤ: 'ɨ',
  ᶥ: 'ɩ',
  ᶦ: 'ɪ',
  ᶧ: 'ᵻ',
  ᶨ: 'ʝ',
  ᶩ: 'ɭ',
  ᶪ: 'ᶅ',
  ᶫ: 'ʟ',
  ᶬ: 'ɱ',
  ᶭ: 'ɰ',
  ᶮ: 'ɲ',
  ᶯ: 'ɳ',
  ᶰ: 'ɴ',
  ᶱ: 'ɵ',
  ᶲ: 'ɸ',
  ᶳ: 'ʂ',
  ᶴ: 'ʃ',
  ᶵ: 'ƫ',
  ᶶ: 'ʉ',
  ᶷ: 'ʊ',
  ᶸ: 'ᴜ',
  ᶹ: 'ʋ',
  ᶺ: 'ʌ',
  ᶻ: 'z',
  ᶼ: 'ʐ',
  ᶽ: 'ʑ',
  ᶾ: 'ʒ',
  ᶿ: 'θ',
  '⁰': '0',
  ⁱ: 'i',
  '⁴': '4',
  '⁵': '5',
  '⁶': '6',
  '⁷': '7',
  '⁸': '8',
  '⁹': '9',
  '⁺': '+',
  '⁻': '−',
  '⁼': '=',
  '⁽': '(',
  '⁾': ')',
  ⁿ: 'n',
}

const glyphRegex = new RegExp(
  `([(${Object.keys(regularGlyphBySubGlyph).join('')}]+|[${Object.keys(
    regularGlyphBySuperGlyph,
  ).join('')}]+)`,
  'g',
)

const invidualGlyphRegex = new RegExp(
  `([(${Object.keys(regularGlyphBySubGlyph).join('')}]+|[${Object.keys(
    regularGlyphBySuperGlyph,
  ).join('')}])`,
  'g',
)

const mergeStrings = (chunks: ReactNode[]) =>
  chunks.reduce((prev: ReactNode[], curr) => {
    if (typeof curr === 'string' && prev.length > 0) {
      const lastEl = prev[prev.length - 1]
      if (typeof lastEl === 'string') {
        return [...prev.slice(0, -1), lastEl + curr]
      }
    }
    return [...prev, curr]
  }, [])

export const renderText =
  (...transformers: ((input: string) => ReactNode)[]) =>
  (input: string) =>
    transformers.reduce(
      (prev, t) =>
        prev.flatMap(chunk => {
          if (typeof chunk === 'string') {
            return t(chunk)
          }
          // chunk already transformed
          return chunk
        }),
      [input] as ReactNode[],
    )

export const renderLinks = (input: string) => {
  let i = 0
  return mergeStrings(
    input
      .split(/(\s)/)
      .filter(group => group !== '')
      .map(chunk => {
        try {
          const url = new URL(chunk)
          if (['http:', 'https:'].includes(url.protocol)) {
            return (
              <a
                key={`link-${i++}`}
                href={url.href}
                rel="noreferrer"
                target="_blank"
              >
                {url.href}
              </a>
            )
          }
        } catch {
          // ignored by design
        }
        return chunk
      }),
  )
}

export const renderFormulas = (input?: string) =>
  input
    ?.split(glyphRegex)
    .filter(chunk => chunk !== '')
    .map((chunk, i) => {
      if (chunk[0] && chunk[0] in regularGlyphBySubGlyph) {
        const replacement = chunk
          .split('')
          .map(c => regularGlyphBySubGlyph[c])
          .join('')
        return <sub key={`sub-${chunk}-${i}`}>{replacement}</sub>
      }
      if (chunk[0] && chunk[0] in regularGlyphBySuperGlyph) {
        const replacement = chunk
          .split('')
          .map(c => regularGlyphBySuperGlyph[c])
          .join('')
        return <sup key={`sup-${chunk}-${i}`}>{replacement}</sup>
      }
      return chunk
    })

const glyphs = { ...regularGlyphBySubGlyph, ...regularGlyphBySuperGlyph }

export const normalizeFormula = (input?: string): string =>
  input?.replace(invidualGlyphRegex, m => glyphs?.[m] ?? m) ?? ''

export const splitAt: (index: number, xs: string) => [string, string] = (
  index,
  xs,
) => [xs.slice(0, index), xs.slice(index)]

export const toDashedSlug = (input: string) =>
  deburr(normalizeFormula(input))
    .trim()
    .replace(/[^\w\-\s]/g, '')
    .replace(/[-_\s]+/g, '-')
    .substring(0, 100)
    .toLowerCase()
